import React, { useState, useRef, useContext} from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonButton, IonGrid, IonRow, IonCol, IonFooter} from '@ionic/react';

import {ZasavaLoginCredentials } from '../components/ZasavaLoginCredentials.js'
import {Jobs } from '../components/Jobs.js'

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

export function ZsavaHome () {



    let authenticated_Zasava_Context = useContext(Auth_Zasava_Context);

    const [acctID, setAcctID] = useState(authenticated_Zasava_Context.acctID);
    const [schema, setSchemaName] = useState(authenticated_Zasava_Context.schema);
    let [sessionID, setSessionID ] = useState(authenticated_Zasava_Context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticated_Zasava_Context.baseURL);


let [zasavaLoginModal, setZasavaLoginModal] = useState(false);
let [jobsData, setJobsData] = useState(false);


const handleHomepage_ghanaVerified = () => {

    if (baseURL === "https://zasava.com/") {
        window.location.href = "https://ghanaverified.com";
    } 
    else if (baseURL === "https://zasavatest.com/") {
        window.location.href = "https://ghanaverifiedtest.com";
    }

};
    
//alert('In ZsavaHome.js');

    return (
        <React.Fragment>
            <IonHeader>
                <IonToolbar>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                            <IonTitle size="large" class="appTitle">Zsava</IonTitle>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                            <IonTitle size="small" class="appTitle"> Internal Management System </IonTitle>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton  onClick={() => setZasavaLoginModal(true)}> Login </IonButton>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton  onClick={() => setJobsData(true)}> Jobs </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonToolbar>
            </IonHeader>
            <IonContent>

            { zasavaLoginModal == true && <ZasavaLoginCredentials openModal={ zasavaLoginModal } closeModal={() => setZasavaLoginModal(false)} ></ZasavaLoginCredentials> }
            {/*<EmployeeLoginCredentials openModal={ employeeLoginModal } closeModal={() => setEmployeeLoginModal(false)} ></EmployeeLoginCredentials>*/}
            {jobsData == true && <Jobs openModal={ jobsData } closeModal={() => setJobsData(false)} data={{
                    status: "zasava_site",
                    }}></Jobs>}   

            </IonContent>

            <IonFooter class='appFooter'>
                    <IonGrid>
                        <IonRow className='gh_bottom_links_row'>
                            {(authenticated_Zasava_Context.authenticated != null && authenticated_Zasava_Context.acctID == "1") &&
                                <IonCol className='gh_bottom_links_col_right' size='2'>
                                    <IonButton className='small_button' onClick={() => handleHomepage_ghanaVerified()}>GH-Verified</IonButton>
                                </IonCol>
                            }
                        </IonRow>
                    </IonGrid>
                </IonFooter>

        </React.Fragment>
    )
}